<template>
  <transition name="fade-slide">
    <div v-if="visible" class="gold-overlay" @click.self="closeGoldRecharge">
      <div class="gold-popup" role="dialog" aria-modal="true" aria-labelledby="gold-recharge-title">
        <button type="button" class="gold-close" aria-label="关闭" @click="closeGoldRecharge">
          <AppIcon name="close" size="sm" aria-label="" />
        </button>

        <template v-if="payStep === 'qrcode'">
          <h2 id="gold-recharge-title" class="gold-title">微信扫码充值</h2>
          <p v-if="selectedPackage" class="gold-hint">
            支付 ¥{{ selectedPackage.payYuan }}，到账 {{ selectedPackage.grantGold }} 橘子币
          </p>
          <div class="gold-qr-wrap">
            <img
              v-if="qrDataUrl"
              :src="qrDataUrl"
              alt="微信充值二维码"
              class="gold-qr-image"
            />
          </div>
          <p class="gold-hint">{{ isConfirmingPayment ? '正在确认支付结果...' : '请使用微信扫一扫完成支付' }}</p>
          <p v-if="errorMessage" class="gold-error">{{ errorMessage }}</p>
          <button type="button" class="gold-submit" :disabled="isConfirmingPayment" @click="confirmPaymentManually">
            {{ isConfirmingPayment ? '确认中...' : '我已完成支付' }}
          </button>
          <button type="button" class="gold-back" @click="backToSelect">重新选择档位</button>
        </template>

        <template v-else-if="payStep === 'success'">
          <h2 class="gold-title">充值成功</h2>
          <p class="gold-hint">橘子币已到账</p>
          <button type="button" class="gold-submit" @click="closeGoldRecharge">完成</button>
        </template>

        <template v-else>
          <div class="gold-title-row">
            <h2 id="gold-recharge-title" class="gold-title">橘子币充值</h2>
            <template v-if="source === 'vol-pay'">
              <span v-if="showNeedRecharge" class="gold-need">还需充值 {{ needRechargeGold }} 橘子币</span>
              <span class="gold-balance">
                <AppIcon name="orangeCoin" size="sm" />
                {{ balanceGold }}
              </span>
            </template>
          </div>
          <div v-if="listLoading" class="gold-hint">加载档位中...</div>
          <div v-else-if="packages.length" class="gold-grid">
            <button
              v-for="pkg in packages"
              :key="pkg.code"
              type="button"
              class="gold-pkg"
              :class="{
                'is-selected': selectedPackageCode === pkg.code,
                'is-recommended': showRecommended && pkg.recommended,
              }"
              :aria-pressed="selectedPackageCode === pkg.code"
              @click="selectPackage(pkg.code)"
            >
              <span
                v-if="showRecommended && pkg.recommended"
                class="gold-pkg-badge"
              >推荐</span>
              <span class="gold-pkg-amount">
                <AppIcon name="orangeCoin" size="md" aria-hidden="true" />
                <span class="gold-pkg-gold">{{ pkg.grantGold }}</span>
              </span>
              <span class="gold-pkg-price">¥{{ pkg.payYuan }}</span>
              <span v-if="pkg.firstRechargeBonusGold > 0" class="gold-pkg-bonus">
                首充加赠 {{ pkg.firstRechargeBonusGold }}
              </span>
            </button>
          </div>
          <p v-if="errorMessage" class="gold-error">{{ errorMessage }}</p>
          <button
            type="button"
            class="gold-submit"
            :disabled="!canSubmitPay"
            @click="submitGoldRecharge"
          >
            {{ payLoading ? '处理中...' : '微信支付' }}
          </button>
          <p class="gold-agree-text">
            支付即同意
            <button type="button" class="gold-link" @click="requestOpenAgreement(agreementCode)">
              《{{ agreementTitle }}》
            </button>
          </p>
        </template>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import AppIcon from '@/shared/components/AppIcon.vue'
import { useGoldRecharge } from '@/features/user/composables/useGoldRecharge'
import { requestOpenAgreement } from '@/shared/utils/payDialogBridge'

const route = useRoute()

const {
  visible,
  listLoading,
  errorMessage,
  packages,
  selectedPackageCode,
  selectedPackage,
  needRechargeGold,
  balanceGold,
  agreementTitle,
  agreementCode,
  source,
  showNeedRecharge,
  showRecommended,
  qrDataUrl,
  payLoading,
  payStep,
  isConfirmingPayment,
  canSubmitPay,
  closeGoldRecharge,
  selectPackage,
  submitGoldRecharge,
  backToSelect,
  confirmPaymentManually,
} = useGoldRecharge()

/** 离开路由时关掉全局充值窗，避免跟到其他页面 */
watch(
  () => route.fullPath,
  (next, prev) => {
    if (prev != null && next !== prev && visible.value) {
      closeGoldRecharge()
    }
  }
)
</script>

<style scoped src="@/features/user/styles/GoldRechargeDialog.css"></style>
